import { FC, cloneElement, isValidElement } from 'react'
import { cn } from '@wellesley/ui'

import { Privacy } from './types'

type TPrivacyItem = Privacy & { className?: string; iconColor?: string }

const PrivacyItem: FC<TPrivacyItem> = ({
  icon,
  label,
  className,
  description,
  iconColor,
}) => {
  const iconElement = icon()
  const renderedIcon =
    iconColor && isValidElement<{ color?: string }>(iconElement)
      ? cloneElement(iconElement, { color: iconColor })
      : iconElement

  return (
    <div className={cn('gap-xxs flex flex-row', className)}>
      <div className="w-5 md:w-[18px]">{renderedIcon}</div>
      <div className="gap-xxxs flex flex-col text-gray-900">
        <p className="text-base font-medium">{label}</p>
        <span className="text-base leading-4 text-gray-500">{description}</span>
      </div>
    </div>
  )
}

export default PrivacyItem
